/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SrvProceedingAssetSnapshotResponse } from './SrvProceedingAssetSnapshotResponse';
import {
    SrvProceedingAssetSnapshotResponseFromJSON,
    SrvProceedingAssetSnapshotResponseFromJSONTyped,
    SrvProceedingAssetSnapshotResponseToJSON,
    SrvProceedingAssetSnapshotResponseToJSONTyped,
} from './SrvProceedingAssetSnapshotResponse';
import type { SrvProceedingCourseEntryResponse } from './SrvProceedingCourseEntryResponse';
import {
    SrvProceedingCourseEntryResponseFromJSON,
    SrvProceedingCourseEntryResponseFromJSONTyped,
    SrvProceedingCourseEntryResponseToJSON,
    SrvProceedingCourseEntryResponseToJSONTyped,
} from './SrvProceedingCourseEntryResponse';
import type { SrvProceedingClaimsSnapshotResponse } from './SrvProceedingClaimsSnapshotResponse';
import {
    SrvProceedingClaimsSnapshotResponseFromJSON,
    SrvProceedingClaimsSnapshotResponseFromJSONTyped,
    SrvProceedingClaimsSnapshotResponseToJSON,
    SrvProceedingClaimsSnapshotResponseToJSONTyped,
} from './SrvProceedingClaimsSnapshotResponse';

/**
 * 
 * @export
 * @interface SrvProceedingResponse
 */
export interface SrvProceedingResponse {
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingResponse
     */
    clientId: string;
    /**
     * 
     * @type {Date}
     * @memberof SrvProceedingResponse
     */
    applicationDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingResponse
     */
    counselingType: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SrvProceedingResponse
     */
    openingDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SrvProceedingResponse
     */
    annulmentDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingResponse
     */
    courtId: string | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingResponse
     */
    fileNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingResponse
     */
    trusteeId: string | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingResponse
     */
    trusteeName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SrvProceedingResponse
     */
    isTrusteeInactive: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingResponse
     */
    insolvencyAdministratorId: string | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingResponse
     */
    insolvencyAdministratorName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SrvProceedingResponse
     */
    isInsolvencyAdministratorInactive: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingResponse
     */
    offeredQuota: number | null;
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingResponse
     */
    acceptedQuota: number | null;
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingResponse
     */
    proceedingCosts: number | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingResponse
     */
    remark: string | null;
    /**
     * 
     * @type {Array<SrvProceedingCourseEntryResponse>}
     * @memberof SrvProceedingResponse
     */
    courseEntries: Array<SrvProceedingCourseEntryResponse>;
    /**
     * 
     * @type {SrvProceedingClaimsSnapshotResponse}
     * @memberof SrvProceedingResponse
     */
    claimsSnapshot: SrvProceedingClaimsSnapshotResponse;
    /**
     * 
     * @type {SrvProceedingAssetSnapshotResponse}
     * @memberof SrvProceedingResponse
     */
    assetSnapshot: SrvProceedingAssetSnapshotResponse | null;
}

/**
 * Check if a given object implements the SrvProceedingResponse interface.
 */
export function instanceOfSrvProceedingResponse(value: object): value is SrvProceedingResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('applicationDate' in value) || value['applicationDate'] === undefined) return false;
    if (!('counselingType' in value) || value['counselingType'] === undefined) return false;
    if (!('openingDate' in value) || value['openingDate'] === undefined) return false;
    if (!('annulmentDate' in value) || value['annulmentDate'] === undefined) return false;
    if (!('courtId' in value) || value['courtId'] === undefined) return false;
    if (!('fileNumber' in value) || value['fileNumber'] === undefined) return false;
    if (!('trusteeId' in value) || value['trusteeId'] === undefined) return false;
    if (!('trusteeName' in value) || value['trusteeName'] === undefined) return false;
    if (!('isTrusteeInactive' in value) || value['isTrusteeInactive'] === undefined) return false;
    if (!('insolvencyAdministratorId' in value) || value['insolvencyAdministratorId'] === undefined) return false;
    if (!('insolvencyAdministratorName' in value) || value['insolvencyAdministratorName'] === undefined) return false;
    if (!('isInsolvencyAdministratorInactive' in value) || value['isInsolvencyAdministratorInactive'] === undefined) return false;
    if (!('offeredQuota' in value) || value['offeredQuota'] === undefined) return false;
    if (!('acceptedQuota' in value) || value['acceptedQuota'] === undefined) return false;
    if (!('proceedingCosts' in value) || value['proceedingCosts'] === undefined) return false;
    if (!('remark' in value) || value['remark'] === undefined) return false;
    if (!('courseEntries' in value) || value['courseEntries'] === undefined) return false;
    if (!('claimsSnapshot' in value) || value['claimsSnapshot'] === undefined) return false;
    if (!('assetSnapshot' in value) || value['assetSnapshot'] === undefined) return false;
    return true;
}

export function SrvProceedingResponseFromJSON(json: any): SrvProceedingResponse {
    return SrvProceedingResponseFromJSONTyped(json, false);
}

export function SrvProceedingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SrvProceedingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'clientId': json['clientId'],
        'applicationDate': (json['applicationDate'] == null ? null : new Date(json['applicationDate'])),
        'counselingType': json['counselingType'],
        'openingDate': (json['openingDate'] == null ? null : new Date(json['openingDate'])),
        'annulmentDate': (json['annulmentDate'] == null ? null : new Date(json['annulmentDate'])),
        'courtId': json['courtId'],
        'fileNumber': json['fileNumber'],
        'trusteeId': json['trusteeId'],
        'trusteeName': json['trusteeName'],
        'isTrusteeInactive': json['isTrusteeInactive'],
        'insolvencyAdministratorId': json['insolvencyAdministratorId'],
        'insolvencyAdministratorName': json['insolvencyAdministratorName'],
        'isInsolvencyAdministratorInactive': json['isInsolvencyAdministratorInactive'],
        'offeredQuota': json['offeredQuota'],
        'acceptedQuota': json['acceptedQuota'],
        'proceedingCosts': json['proceedingCosts'],
        'remark': json['remark'],
        'courseEntries': ((json['courseEntries'] as Array<any>).map(SrvProceedingCourseEntryResponseFromJSON)),
        'claimsSnapshot': SrvProceedingClaimsSnapshotResponseFromJSON(json['claimsSnapshot']),
        'assetSnapshot': SrvProceedingAssetSnapshotResponseFromJSON(json['assetSnapshot']),
    };
}

export function SrvProceedingResponseToJSON(json: any): SrvProceedingResponse {
    return SrvProceedingResponseToJSONTyped(json, false);
}

export function SrvProceedingResponseToJSONTyped(value?: SrvProceedingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'clientId': value['clientId'],
        'applicationDate': value['applicationDate'] == null ? value['applicationDate'] : `${value['applicationDate'].getFullYear()}-${String(value['applicationDate'].getMonth()+1).padStart(2,'0')}-${String(value['applicationDate'].getDate()).padStart(2,'0')}`,
        'counselingType': value['counselingType'],
        'openingDate': value['openingDate'] == null ? value['openingDate'] : `${value['openingDate'].getFullYear()}-${String(value['openingDate'].getMonth()+1).padStart(2,'0')}-${String(value['openingDate'].getDate()).padStart(2,'0')}`,
        'annulmentDate': value['annulmentDate'] == null ? value['annulmentDate'] : `${value['annulmentDate'].getFullYear()}-${String(value['annulmentDate'].getMonth()+1).padStart(2,'0')}-${String(value['annulmentDate'].getDate()).padStart(2,'0')}`,
        'courtId': value['courtId'],
        'fileNumber': value['fileNumber'],
        'trusteeId': value['trusteeId'],
        'trusteeName': value['trusteeName'],
        'isTrusteeInactive': value['isTrusteeInactive'],
        'insolvencyAdministratorId': value['insolvencyAdministratorId'],
        'insolvencyAdministratorName': value['insolvencyAdministratorName'],
        'isInsolvencyAdministratorInactive': value['isInsolvencyAdministratorInactive'],
        'offeredQuota': value['offeredQuota'],
        'acceptedQuota': value['acceptedQuota'],
        'proceedingCosts': value['proceedingCosts'],
        'remark': value['remark'],
        'courseEntries': ((value['courseEntries'] as Array<any>).map(SrvProceedingCourseEntryResponseToJSON)),
        'claimsSnapshot': SrvProceedingClaimsSnapshotResponseToJSON(value['claimsSnapshot']),
        'assetSnapshot': SrvProceedingAssetSnapshotResponseToJSON(value['assetSnapshot']),
    };
}

